import { defineComponent as _defineComponent } from 'vue';
import { GoogleMap } from 'vue3-google-map';
import mapStyle from '@/helpers/map-style';
import { Loader } from '@googlemaps/js-api-loader';
export default /*#__PURE__*/ _defineComponent({
    __name: 'map',
    props: {
        latitude: { type: Number, required: true },
        longitude: { type: Number, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const loader = new Loader({
            apiKey: 'AIzaSyBPiRgAIrR46zIA1FvI7TmwPNe6qxL2LJc',
            libraries: ['drawing', 'geometry', 'places'],
            language: 'nl-NL',
            region: 'NL',
        });
        const apiPromise = loader.load();
        const center = { lat: props.latitude, lng: props.longitude };
        const __returned__ = { props, loader, apiPromise, center, get GoogleMap() { return GoogleMap; }, get mapStyle() { return mapStyle; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
